var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRCartBuyDiscF2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph-megaphone-light"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-cart-buy-disc-f2",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconR-cart-buy",
    d: "M16.492,32.258c-1.598,0 -2.896,1.298 -2.896,2.896c0,1.599 1.298,2.896 2.896,2.896c1.598,0 2.896,-1.297 2.896,-2.896c0,-1.598 -1.298,-2.896 -2.896,-2.896Zm16.5,-0.005c-1.599,0 -2.896,1.298 -2.896,2.896c-0,1.598 1.297,2.896 2.896,2.896c1.598,0 2.896,-1.298 2.896,-2.896c-0,-1.598 -1.298,-2.896 -2.896,-2.896Zm-19.534,-17.404c0,-0 -2.94,-0.017 -2.944,-0.017c-0.36,-0 -0.73,-0.36 -0.73,-0.756c0,-0.1 0,-0.1 0,-0.678c0,-0.387 0.374,-0.743 0.73,-0.743c0.002,-0 3.757,0.017 3.757,0.017c-0,-0 0.761,-0.002 1.034,0.743c0.379,1.037 0.407,1.102 0.529,1.434c0.354,0 1.144,-0 3.204,-0c0.03,-0 0.06,0.012 0.081,0.033c0.022,0.022 0.034,0.051 0.034,0.082l0,1.946c0,0.063 -0.052,0.115 -0.115,0.115c-0,0 -2.418,0.006 -2.418,0.006l4.678,12.853c0,0 16.692,-3.868 16.692,-3.868c-0,0 -0.001,-8.995 -0.001,-8.995l-1.965,-0c-0.063,-0 -0.115,-0.052 -0.115,-0.116l-0,-1.941c-0,-0.031 0.012,-0.06 0.034,-0.082c0.021,-0.021 0.051,-0.033 0.081,-0.033l2.731,0c0.766,-0 1.461,0.726 1.461,1.45c-0,0.016 -0.005,7.833 -0.005,10.151c-0,1.261 -1.058,1.544 -1.359,1.622c0,0 -16.812,3.863 -18.06,4.149c-0.254,0.058 -0.438,0.014 -0.489,0.006c-0.559,-0.087 -0.73,-0.573 -0.758,-0.64c-0,0 -5.65,-15.529 -6.087,-16.738Zm13.843,8.666c-0.07,-0.014 -0.211,-0.063 -0.211,-0.063c-0.069,-0.029 -0.128,-0.06 -0.184,-0.097c0,0 -0.003,-0.002 -0.007,-0.004c-0.065,-0.043 -0.121,-0.09 -0.172,-0.141l-3.573,-3.573c-0.2,-0.2 -0.324,-0.477 -0.324,-0.782c0,-0.611 0.496,-1.107 1.107,-1.107c0.306,0 0.582,0.124 0.783,0.324l1.684,1.685l0,-6.7c0,-0.612 0.496,-1.107 1.107,-1.107c0.611,-0 1.107,0.495 1.107,1.107l-0,6.7l1.684,-1.685c0.201,-0.2 0.477,-0.324 0.783,-0.324c0.611,0 1.107,0.496 1.107,1.107c-0,0.305 -0.124,0.582 -0.324,0.782l-3.573,3.573c-0.051,0.051 -0.107,0.097 -0.168,0.138l-0.188,0.102c0,-0 -0.017,0.006 -0.021,0.008c-0.054,0.022 -0.2,0.057 -0.203,0.058c-0.062,0.013 -0.132,0.02 -0.204,0.02c-0.072,-0 -0.141,-0.007 -0.21,-0.021Z",
    style: {
      fill: "#f2f2f2"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRCartBuyDiscF2);
export default __webpack_public_path__ + "static/media/iconR-cart-buy-disc-f2.9bd3cdd7f32a9130669255b11d9d293c.svg";
export { ForwardRef as ReactComponent };